import { createGlobalStyle } from 'styled-components';
import { tme, defaultTheme, superclient, superclient1, honda } from './vendors';

import { darken, lighten } from 'polished';

const clr_pri = (props) => {
    return props.theme?.color;
};
const font = (props) => {
    return props.theme?.font;
};

const ratingColor = (props) => {
    return props?.theme?.ratingColor;
};

const iconBackgroundColor = (props) => {
    return props.theme?.iconBackgroundColor;
};

const responseBubbleBackgroundColor = (props) => {
    return props.theme?.responseBubbleBackgroundColor;
};

const starRatingColor = (props) => {
    return props.theme?.starRatingColor;
};

const headerBackground = (props) => {
    return props.theme?.headerColor;
};

const bubbleBackground = (props) => {
    return props.theme?.bubbleBackgroundColor;
};

const thankYouColor = (props) => {
    return props.theme?.thankYouColor;
};

const unsubscribeColor = (props) => {
    return props.theme?.unsubscribeColor;
};

const expireColor = (props) => {
    return props.theme?.expireColor ? props.theme?.expireColor : '#101013';
};

const background = (props) => {
    return props.theme?.background;
};

const btnColor = (props) => {
    return props.theme?.btnColor;
};

const textColor = (props) => {
    return props.theme?.textColor;
};

const secondaryColor = (props) => {
    return props.theme?.secondaryColor;
};

const _darken = (props, percentage) => {
    return clr_pri(props) ? darken(percentage, props.theme?.color) : clr_pri(props);
};
const _lighten = (props, percentage) => {
    return lighten(percentage, props.theme?.color);
};
// const imageWidth = (props) => {
//   return props.theme?.chatBotImageWidth;
// };

// const imageHeight = (props) => {
//   return props.theme?.chatBotImageHeight;
// };

export const GlobalStyles = createGlobalStyle`
//Theme Colors

//Theme Colors
.survey-header {
  background: ${headerBackground};
}
.body--survey {
  background: ${background};
}

.main {
  background: ${background};
}
.chat-container {
  font-family: ${font};
}

.mentions {
  font-family: ${font};
}

.mentions--multiLine .mentions__control {
  font-family: ${font};
}

.mentions__mention {
  font-family: ${font};
}

.chat-img {
  background: ${iconBackgroundColor};
}

.right-chat .chat-bubble {
  background: ${responseBubbleBackgroundColor};
  color: ${secondaryColor};
}
.chat-question {
  color: ${textColor};
}

.chat-bubble {
  font-family: ${font};
  background-color: ${bubbleBackground};
}
.rating__list li .rating__label {
  border-color: ${(props) => _darken(props, 0.3)};
  color: ${textColor};
}
.rating__label {
  .placeholder {
    color: ${textColor};
  }
}
.btn--undo {
  color: ${textColor};
  background-color:${background};
  &:hover {
    background-color: ${clr_pri};
    color: ${secondaryColor};
  }
}

.btn--skip {
  color: ${textColor};
  background-color:${btnColor};
  &:hover {
    background-color: ${clr_pri};
    color: ${secondaryColor};
  }
}
.chat-field input, .chat-field input[type=text], .chat-field input[type=url], .chat-field input[type=email], .chat-field input[type=password] {
  font-family: ${font};
}
header{
  background: ${headerBackground};
  &.expired {
    background: ${expireColor};
  }
  &.surveyexpired {
    background: ${expireColor};
  }
  &.unsubscribed {
    background: ${unsubscribeColor};
  }
  &.surveycompleted {
    background: ${thankYouColor};
  }
  &.completed {
    background: ${thankYouColor};
  }
  h2 {
    color: ${textColor}
  }
}
.slider-legends-text div {
  color: ${textColor};
  background-color:${background};
}
.checkbox-list li input[type="checkbox"] + label  {
  background-color:${btnColor};
  border-color: ${(props) => _darken(props, 0.3)};
  color: ${textColor};
}

.checkbox-list li input[type="checkbox"]:checked + label:before {
  color: ${clr_pri};
}

.radio-list li input[type="radio"]:checked + label:before{
  color: ${clr_pri};
  box-shadow: inset 0 0 0 0.2em white, inset 0 0 0 1em ${clr_pri};
  border: 1px solid ${clr_pri};
}

.checkbox-list li input[type="checkbox"]:checked + label {
  background-color:${secondaryColor};
  
}



.question-remaining{
  color: ${textColor};
}
.time-remaining{
  color: ${textColor};
}
.p-progressbar .p-progressbar-value{
  background-color: ${clr_pri};
}

.rating__list li .rating__field:checked + label {
  background-color: ${ratingColor};
  color:${secondaryColor};
  .placeholder {
    color: ${secondaryColor};
  }
}
.btn.btn--outline.btn--radio {
  color: ${textColor};
  background-color: ${btnColor};
  &:hover {
    border-color: ${clr_pri};
  }
}

.btn.btn--send.active {
  background-color: ${clr_pri};
}

.thankyou__content {
  font-family: ${font};
}
.not-applicapable .btn-applicapable{
  background: ${btnColor};
  border-color: ${(props) => _darken(props, 0.3)};
  color: ${textColor};
  &:hover{
    border-color: ${clr_pri};
  }
}
.not-applicapable-star .btn-applicapable.with--na{    
  background: ${btnColor};
  border-color: ${(props) => _darken(props, 0.3)};
  color: ${textColor};
  &:hover{
    border-color: ${clr_pri};
  }

}
.not-applicapable .btn-applicapable.active {
  background: ${ratingColor};
  color: ${secondaryColor};
}
.not-applicapable-star .btn-applicapable.active {
  background: ${starRatingColor};
  color: ${secondaryColor};
}
`;

export const theme = {
    tme,
    defaultTheme,
    'super client': superclient,
    'super client 1': superclient1,
    'hondana.clearview': honda
};
